import { reduce, map, clone, times, merge, sortBy } from 'lodash';

import { isPlanFree, isPlanCustom } from 'common/util/plan.util';

import './plans.style.sass';
import template from './plans.tpl.pug';

class PlansController {
    /* @ngInject */
    constructor(planService) {
        this.planService = planService;
    }

    $onInit() {
        this.selectYearly();
    }

    $onChanges(changeObject) {
        if (changeObject.plans) {
            let maxFeatureCount = reduce(this.plans || [], (max, plan) => Math.max(plan.features.length, max), 0);

            let plans = map(this.plans || [], (plan) => {
                plan = clone(plan);

                let features = plan.features || [];
                plan.features = features.concat(times(maxFeatureCount - features.length, () => ''));

                plan.subscriptions = map(plan.subscriptions || [], (subscription) => {
                    if (subscription.price === 0) {
                        return merge({}, subscription, {
                            currency: subscription.currency || this.getDefaultCurrency(this.plans || [])
                        });
                    }

                    return subscription;
                });

                return plan;
            });

            this.plans = sortBy(plans, (plan) => {
                return isPlanFree(plan)
                    ? -1
                    : isPlanCustom(plan)
                        ? 1
                        : 0;
            });

            this.freeMonths = Math.round(this.planService.getFreeMonthsCount(this.plans || [], this.planService.PaymentFrequency.Monthly, this.planService.PaymentFrequency.Yearly));
            this.updateSubscriptions(this.plans, this.frequency);
        }
    }

    getDefaultCurrency(plans) {
        return reduce(plans || [], (currency, plan) => {
            return reduce(plan.subscriptions || [], (currency, subscription) => currency || subscription.currency, currency);
        }, null);
    }

    get monthly() {
        return this.frequency === this.planService.PaymentFrequency.Monthly;
    }

    updateSubscriptions(plans, frequency) {
        plans = plans || [];

        plans.forEach((plan) => {
            plan.subscription = this.planService.getSubscriptionByFrequency(plan, frequency);
        });
    }

    selectMonthly() {
        this.frequency = this.planService.PaymentFrequency.Monthly;
        this.updateSubscriptions(this.plans, this.frequency);
    }

    selectYearly() {
        this.frequency = this.planService.PaymentFrequency.Yearly;
        this.updateSubscriptions(this.plans, this.frequency);
    }

    select(plan, subscription) {
        return this.onSelect({
            plan,
            subscription
        });
    }
}

export default {
    selector: 'dbPlans',
    template: template(),
    controller: PlansController,
    bindings: {
        plans: '<',
        upgrade: '<',
        onSelect: '&'
    }
};



// WEBPACK FOOTER //
// ./src/common/component/plans/plans.cmpt.js